import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import ContactsDataGrid from '../../../Contacts/Page/ContactsDataGrid'
import { MemberStatus } from '../../../../utils/enums';
import useApiManager from '../../../../utils/Api/apiManager';

const ContactsDialog = ({ open, setOpen, accountId, fetchContacts }) => {
    const [selectedRows, setSelectedRows] = useState(null); // State to store selected row ID
    const { post } = useApiManager();

    const handleClose = () => {
        setOpen(false);
    };

    // Handler to capture selected row ID
    const handleSelectionChange = (newSelection) => {
        setSelectedRows(newSelection); // Store selected row IDs
    };

    const handleAddContact = async () => {
        try {
            const responseData = await post(`/accounts/${accountId}/contacts/assign`, {
                contactIds: selectedRows
            });
            console.log('Form Submitted Successfully:', responseData);
            handleClose();
            fetchContacts();
            
            // Handle success (e.g., show a notification, redirect, etc.)
        } catch (error) {
            console.error('Failed to submit form:', error);
            // Handle error (e.g., show an error message)
        }
    };
    return (
        <Dialog
            fullWidth
            maxWidth={'md'}
            open={open}
            onClose={handleClose}
        >
            <DialogTitle>Choose Contact</DialogTitle>
            <DialogContent>
                <Box sx={{ height: 300 }}>
                    <ContactsDataGrid
                        onSelectionModelChange={handleSelectionChange} 
                        unassigned={true}/>
                </Box>

            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Close</Button>
                <Button onClick={handleAddContact}>Add Contact</Button>
            </DialogActions>
        </Dialog>
    )
};

export default ContactsDialog;